module.exports = __webpack_public_path__ + "img/ck-ranking-empty.8fa88d56.png";